<template>
  <div class="padres-container">
    <div class="overlay-rosado" />
  
    <!-- Contador -->
    <div
      ref="contadorRef"
      class="contador-container"
    >
      <div class="contador-titulo">
        <span
          ref="soloRef"
          class="solo"
        >Solo</span>
        <span
          ref="faltanRef"
          class="faltan"
        >Faltan</span>
      </div>
      <div class="contador-numeros">
        <div
          ref="tiempoRef1"
          class="tiempo"
        >
          <span class="numero">{{ dias }}</span>
          <span class="etiqueta">Días</span>
        </div>
        <div
          ref="tiempoRef2"
          class="tiempo"
        >
          <span class="numero">{{ horas }}</span>
          <span class="etiqueta">Horas</span>
        </div>
        <div
          ref="tiempoRef3"
          class="tiempo"
        >
          <span class="numero">{{ minutos }}</span>
          <span class="etiqueta">Minutos</span>
        </div>
        <div
          ref="tiempoRef4"
          class="tiempo"
        >
          <span class="numero">{{ segundos }}</span>
          <span class="etiqueta">Segundos</span>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import gsap from 'gsap';
  
  export default {
    name: 'BienvenidaPadresPage',
    setup() {
      const contadorRef = ref(null);
      const soloRef = ref(null);
      const faltanRef = ref(null);
      const tiempoRef1 = ref(null);
      const tiempoRef2 = ref(null);
      const tiempoRef3 = ref(null);
      const tiempoRef4 = ref(null);
  
      const dias = ref('00');
      const horas = ref('00');
      const minutos = ref('00');
      const segundos = ref('00');
  
      const cuentaAtras = () => {
        const evento = new Date('2025-05-30T19:00:00');
        setInterval(() => {
          const ahora = new Date();
          const diferencia = evento - ahora;
  
          if (diferencia > 0) {
            dias.value = String(Math.floor(diferencia / (1000 * 60 * 60 * 24))).padStart(2, '0');
            horas.value = String(Math.floor((diferencia / (1000 * 60 * 60)) % 24)).padStart(2, '0');
            minutos.value = String(Math.floor((diferencia / (1000 * 60)) % 60)).padStart(2, '0');
            segundos.value = String(Math.floor((diferencia / 1000) % 60)).padStart(2, '0');
          }
        }, 1000);
      };
  
      const animateOnScroll = (el, delay = 0) => {
        if (!el.value) return;
        const element = el.value;
        const observer = new IntersectionObserver(([entry], obs) => {
          if (entry.isIntersecting) {
            gsap.to(element, {
              opacity: 1,
              y: 0,
              duration: 1,
              delay,
              ease: 'power2.out'
            });
            obs.unobserve(entry.target);
          }
        }, { threshold: 0.3 });
  
        element.style.opacity = 0;
        element.style.transform = 'translateY(50px)';
        observer.observe(element);
      };
  
      onMounted(() => {
        cuentaAtras();
  
        animateOnScroll(contadorRef, 0.1);
        animateOnScroll(soloRef, 0.2);
        animateOnScroll(faltanRef, 0.3);
        animateOnScroll(tiempoRef1, 0.4);
        animateOnScroll(tiempoRef2, 0.5);
        animateOnScroll(tiempoRef3, 0.6);
        animateOnScroll(tiempoRef4, 0.7);
      });
  
      return {
        contadorRef,
        soloRef,
        faltanRef,
        tiempoRef1,
        tiempoRef2,
        tiempoRef3,
        tiempoRef4,
        dias,
        horas,
        minutos,
        segundos
      };
    }
  };
  </script>
  
  <style scoped>
  .padres-container {
    position: relative;
    width: 100%;
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }
  
  .overlay-rosado {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  
  .contador-container {
  margin-top: 20px;
  text-align: center;
  color: white;
  z-index: 2;
  position: relative;
  padding: 30px 10px;
  background: linear-gradient(rgb(241,174,183,255), rgb(237, 178, 210)),
    url('@/assets/fondo.jpg');
  width: 100%;
  max-width: 600px;
  opacity: 0;
  transform: translateY(50px);

  /* Sombra mejorada estilo 3D */
  box-shadow:
    0 8px 20px rgba(49, 30, 174, 0.15),
    0 12px 30px rgba(0, 0, 0, 0.1),
    0 4px 6px rgba(0, 0, 0, 0.08);
}

  
  .contador-titulo {
    font-size: 40px;
    margin-bottom: 20px;
  }
  
  .contador-titulo .solo {
    font-family: 'FeelingPassionate', cursive;
    font-size: 32px;
    display: block;
    opacity: 0;
  }
  
  .contador-titulo .faltan {
    font-family: serif;
    font-size: 48px;
    letter-spacing: 1px;
    display: block;
    opacity: 0;
  }
  
  .contador-numeros {
    display: flex;
    justify-content: space-around;
    gap: 10px;
  }
  
  .tiempo {
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    transform: translateY(50px);
  }
  
  .numero {
    font-size: 40px;
    font-weight: bold;
    font-family: 'Oswald', sans-serif;
  }
  
  .etiqueta {
    font-size: 14px;
    font-family: 'Oswald', sans-serif;
    margin-top: 5px;
  }
  </style>
  